export const CUSTOMER = "CUSTOMER"
export const CUSTOMER_PURCHASER = "CUSTOMER_PURCHASER"
export const SALES_ASSISTANT = "SALES_ASSISTANT"
export const SUPERVISOR = "SUPERVISOR"
export const ENGINEER = "ENGINEER"
